import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PropertyStepOne from './StepOne';
import PropertyStepTwo from './StepTwo';
import './PropertyDetails.scss';
import { httpsCallable } from 'firebase/functions';
import { functionsB } from '../firebaseConfig';
import { functions } from '../firebaseConfig';
import LoadingPage from './LoadingPage';

function PropertyDetails() {
  const [propertyDetails, setPropertyDetails] = useState({
    postcode: '',
    propertyType: '',
    bedrooms: '',
    isRental: null,
    name: '',
    email: '',
    phone: '',
    area: '',
    address: '',
  });

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    setPropertyDetails((prevDetails) => ({
      ...prevDetails,
      [name]: name === 'isRental' ? value === true || value === 'true' : value,
    }));
  };

  // Proceed to the next step
  const handleNext = () => {
    // Save property details to sessionStorage after Step 1
    sessionStorage.setItem('propertyDetails', JSON.stringify(propertyDetails));
    setStep(2);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Set loading state to true

    try {
      // Save final property details to sessionStorage before API call
      sessionStorage.setItem('propertyDetails', JSON.stringify(propertyDetails));
      console.log('HERE Property details:', propertyDetails);



      // REINSTATE THIS CODE AFTER TESTING ///////////////
      /////////////////////////////////////////////
      const getValuation = httpsCallable(functions, 'getValuation');
      const result = await getValuation({
        postcode: propertyDetails.postcode,
        bedrooms: propertyDetails.bedrooms,
        isRental: propertyDetails.isRental,
        propertyType: propertyDetails.propertyType,
        name: propertyDetails.name,
        email: propertyDetails.email,
        phone: propertyDetails.phone,
        area: propertyDetails.area,
        address: propertyDetails.address,
      });

      // Store the valuation result in sessionStorage for the Valuation page
      sessionStorage.setItem('valuationResult', JSON.stringify(result.data));

      console.log('\n\n555Valuation result:', result.data);
      console.log('\n\n777Valuation result:', result.data.data.average);
      console.log('eeeProperty details:', propertyDetails);

      /////////////////////////////////////////////

      const valPriceRaw = result.data.data.average;

        // Extract valuationPrice and estimatedBounds from result data
      const valuationPrice = valPriceRaw ? `£${valPriceRaw}` : '';
      console.log('Valuation price:', valuationPrice);

      const estimatedBounds = result.data.data['70pc_range'] ? `£${result.data.data['70pc_range'][0]}-£${result.data.data['70pc_range'][1]}` : '';

      console.log('Estimated bounds:', estimatedBounds);

      const emailData = {
        postcode: propertyDetails.postcode,
        bedrooms: propertyDetails.bedrooms,
        isRental: propertyDetails.isRental,
        propertyType: propertyDetails.propertyType,
        name: propertyDetails.name,
        email: propertyDetails.email,
        phone: propertyDetails.phone,
        area: propertyDetails.area,
        address: propertyDetails.address,
        valuationPrice: valuationPrice,
        estimatedBounds: estimatedBounds,
      };
      console.log('\n\nStoring valuation');
      let storeResult; // Declare result in the outer 
      const storeValuation = httpsCallable(functionsB, 'storeValuation');
      try {
        storeResult = await storeValuation(emailData);
        console.log('Valuation stored successfully:', storeResult.data);
      } catch (error) {
        console.error('Error storing valuation:', error.message);
      }


        
      try {
        const sendValuationEmail = httpsCallable(functions, 'sendValuationEmail');
        console.log("Email:", propertyDetails.email);
        console.log("Name:", propertyDetails.name);
        console.log("Unique ID:", storeResult.data.id);
        console.log("Estimated Valuation:", valuationPrice);
        console.log("Estimated Range:", estimatedBounds);
        console.log("Address:", propertyDetails.address);
        await sendValuationEmail({
          email: propertyDetails.email,
          name: propertyDetails.name,
          uniqueId: storeResult.data.id,
          estimatedValuation: valuationPrice,
          estimatedRange: estimatedBounds,
          address: propertyDetails.address,
        });
        console.log("Valuation email sent successfully");
  
      } catch (emailError) {
        console.error("Error sending valuation email:", emailError.message);
       
      }

      /////////////////////////////////////////////

      // Check for the `ad=new` parameter before navigating to the valuation page
      const currentSearchParams = new URLSearchParams(location.search);
      const adVersion = currentSearchParams.get('ad');

      // If `ad=new`, navigate to Valuation2, otherwise go to ValuationPage
      if (adVersion === 'new') {
        navigate('/valuation2');  // Navigate to Valuation2 for `ad=new`
      } else {
        navigate('/valuation');  // Navigate to regular Valuation page
      }
    } catch (error) {
      console.error('Error fetching valuation:', error.message);
    } finally {
      setLoading(false); // Reset loading state
    }
  };

  if (loading) {
    return <LoadingPage />; // Display loading page if loading
  }

  return (
    <div className="property-details">

      {step === 1 && (
        <PropertyStepOne
          propertyDetails={propertyDetails}
          handleChange={handleChange}
          handleNext={handleNext}
        />
      )}
      {step === 2 && (
        <PropertyStepTwo
          propertyDetails={propertyDetails}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
        />
      )}
    </div>
  );
}

export default PropertyDetails;
